import { Type } from '@angular/core';

export interface ContainerComponent {
  childComponentType: Type<any>;
}
